var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._b({staticClass:"date-container",domProps:{"innerHTML":_vm._s(_vm.formatted)}},'span',_vm.config.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }